<template>
    <div class="def-counter">
        <div @click="handlerReduce" class="def-counter__control">
            <svg class="def-counter__minus">
                <use xlink:href="#svg-minus"></use>
            </svg>
        </div>
        <input @change="handlerChange" type="input" class="def-counter__input" :value="count">
        <div @click="handlerIncrease" class="def-counter__control">
            <svg class="def-counter__plus">
                <use xlink:href="#svg-plus"></use>
            </svg>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'DefCounter',
    props: {
        result: {
            type: Object,
            default: () => (
                {
                    "id":"50686","basket_id":"122492",
                    "name":"119158420101",
                    "count":1,
                    "detailPage":"/catalog/detail.php#?ID=#ELEMENT_ID",
                    "price":{"price":0,"priceOld":0},
                    "picture":{"alt":"119158420101","src":"/local/templates/love-you/images/crash_photo.jpeg"},
                    "article":"50686",
                    "displayProperties": {
                        "SIZES": {
                            "value":"15_5","name":"Размер"
                        }
                    }
                })
        }
    },
    data(){
        return {
            min: 1,
            max: 999,
            step: 1,
        }
    },
    computed: {
        count() {
            return parseInt(this.result.count)
        }
    },
    methods: {
        ...mapActions({
            basketUpdate: 'basket/update',
        }),
        handlerIncrease() {
            if (this.count >= this.max) return;
            let id = this.result.id;
            if (this.result.offer && this.result.offer.id) {
                id = this.result.offer.id;
            }
            this.basketUpdate({ id, count: this.count + this.step });
        },
        handlerReduce() {
            if (this.count <= this.min) return;
            let id = this.result.id;
            if (this.result.offer && this.result.offer.id) {
                id = this.result.offer.id;
            }
            this.basketUpdate({ id, count: this.count - this.step });
        },
        handlerChange({target}) {
            const value = Number(target.value);
            let id = this.result.id;
            if (this.result.offer && this.result.offer.id) {
                id = this.result.offer.id;
            }
            if (value >= this.max) {
                this.basketUpdate({ id, count: this.max });
                target.value = this.max;
            } else if (value <= this.min) {
                this.basketUpdate({ id, count: this.min });
                target.value = this.min;
            } else {
                this.basketUpdate({ id, count: value });
            }
        }
    },
}
</script>

<style lang="scss">
.def-counter{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90px;
    height: 32px;
    background-color: #F7F8F9;
    &__input{
        width: 30px;
        flex-shrink: 0;
        padding: 0;
        text-align: center;
        border: none;
        margin: 0 5px;
        background-color: transparent;
        transform: translateY(2px);
        font-weight: 500;
        font-size: rem(16);
        line-height: 115%;
        letter-spacing: 0.08em;
        color: #363636;
    }
    &__control{
        display: flex;
        align-items: center;
        width: 18px;
        height: 18px;
        &:hover{
            cursor: pointer;
        }
    }
    &__minus{
        fill: black;
        width: 18px;
        height: 18px;
    }
    &__plus{
        width: 14px;
        height: 14px;
        @include point-md{
            width: 12px;
            height: 12px;
        }
        @include point-lg{
            width: 18px;
            height: 18px;
        }
    }
}
</style>